<template>
    <div class="outer-content">
        <div class="inner-content">
            <div class="upper-panel">
                <div class="header" v-html="T('Create_Or_Join_Session')"></div>
            </div>

            <div class="d-flex justify-content-center align-items-center flex-column">
                <div class="button-container position-absolute w-100 d-flex justify-content-center align-items-center">
                    <div class="button-container-inner d-flex justify-content-between align-items-center">
                        <div class="game-mode-button" @click="$emit('create-session')">
                            <div class="create-session-icon"></div>
                            <div class="game-mode-text" v-html="T('Create_1')"></div>
                        </div>
                        <div class="game-mode-button" @click="$emit('join-session')">
                            <div class="join-session-icon"></div>
                            <div class="game-mode-text" v-html="T('Join_1')"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="shared-back-button" v-html="T('button_back')" @click="$emit('back')">
            </div>            
        </div>
    </div>
</template>
  
<script lang="ts">
import { T } from '@/App.vue';
import Vue from 'vue';

export default Vue.extend({
    name: 'CreateOrJoinSession',
    methods: {
        T(key: string): string {
            return T(key);
        }
    }
});
</script>
<style scoped lang="less">
.game-mode-button {
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.game-mode-text {
    margin-top: 262px;
}

.create-session-icon {
    position: absolute;
    height: 278px;
    width: 278px;
    top: 0px;
    background-image: url("../assets-fca/UI/icon_create_session.svg");
}

.join-session-icon {
    position: absolute;
    height: 278px;
    width: 278px;
    top: 0px;
    background-image: url("../assets-fca/UI/icon_multi_player.svg");
}
</style>
  